document.addEventListener("DOMContentLoaded", () => {
    const variantData = JSON.parse(
        document.getElementById("variant-metafields-data").textContent,
    );

    function updateVariantMessage(variantID) {
        if (!variantID) return;

        // データがないバリアントは「空」として扱い、前の値が残らないようにする
        const data = variantData[variantID] || {};

        // テーマによってはバリアント変更時にDOMが差し替わるので、毎回取得する
        const additionalMessage = document.querySelector("[data-additional-message]");
        const alertMessage = document.querySelector("[data-alert-message]");
        const preorderInput = document.querySelector("[data-preorder-input]");

        if (additionalMessage) {
            additionalMessage.innerHTML = data.preorder || "";
            additionalMessage.style.display = data.preorder ? "block" : "none";
        }

        if (alertMessage) {
            alertMessage.innerHTML = data.alertmessage || "";
            alertMessage.style.display = data.alertmessage ? "block" : "none";
        }

        if (preorderInput) {
            const value = data.preorder || "";
            preorderInput.value = value;
            preorderInput.disabled = !value;
        }
    }
    const variantForm = document.querySelector(".variant-picker__form");
    const initialVariantId = variantForm?.querySelector('[name="id"]')?.value;
    updateVariantMessage(initialVariantId);

    document.addEventListener("shopify:product:select", (event) => {
        updateVariantMessage(event.detail?.variantId);
    });
});